// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HQ-K","newExpiryDate":"styles_newExpiryDate__2LCAN","footer":"styles_footer__2nFgy"};